import { Component, OnInit, TemplateRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { SoaImageService } from './../../services/soa-image.service';
import { DatePipe } from '@angular/common';
import { ContactService } from './../../services/contact.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FactoringInvoiceService } from './../../services/factoring-invoice.service';
import { FactoringTabService } from './../../services/factoring-tab.service';
import { EncrDecrService } from './../../services/encr-decr.service';
import { CompanyService } from './../../services/company.service';

declare var $: any;

@Component({
  selector: 'app-factoring-tab2',
  templateUrl: './factoring-tab2.component.html',
  styleUrls: ['./factoring-tab2.component.css']
})
export class FactoringTab2Component implements OnInit {
  maxDate: Date;
  modalRef: BsModalRef;
  config: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };

  config1: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-xl'
  };

  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  factTabList: any = [];
  customerList: object = [];
  customerModel: any = {};
  customerModel1: any = {};
  FactFolderList: any;
  mobileFolderList: any = [];
  temp_var: any = false;
  model: any = {};
  customer_id: any = '';
  invoice_id: any = '';
  delete_id: any = '';

  arrayOne(n: number): any[] {
    return Array(n);
  }

  pdfSrc: any = '';
  masterSelected: boolean;
  checklist: any;
  multiSelect: boolean = false;
  isSelected: boolean = false;
  inEditMode = false;
  checkedList: any;
  checked: any;
  item: any;
  checkbox: any;

  Follow_list = [];
  data: any;
  emailModel: any = {};
  folderid: any = 0;
  loaderMode = false;
  create_soa_btn: boolean = true;

  emailModal: any = true;
  emailModalError: any = false;
  submitted = false;

  isSoaChecked: any = false;
  invoice_total: any = '0.00';
  advance_rate: any = '';
  calculatedAdvanceRate: any = '0.00';
  primaryAccountAmount: any = '0.00';
  isReadonly: any = false;
  isBtnDisabled: any = false;
  errorMsg: any = false;
  submitForm: FormGroup;

  constructor(
    private modalService: BsModalService,
    private _factTap2: FactoringTabService,
    private _contact: ContactService,
    private _soaImage: SoaImageService,
    private _router: Router,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private SoaImageService: SoaImageService,
    private _factInvoice: FactoringInvoiceService,
    private datePipe: DatePipe,
    private EncrDecr: EncrDecrService,
    private _companyService: CompanyService
  ) { }

  get dynamicFields() {
    return this.submitForm.controls["dynamicFields"] as FormArray;
  }

  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');
    /////////// s code
    this.customerList = [];
    this.checkbox = [];
    this.data = [];
    this.item = [];

    this.getfactInvoice();

    //get customer for mobile and other role user
    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
    }
    this._contact.getContactList(customerModal)
      .subscribe(
        res => {
          this.customerModel['customer'] = 0;
          this.customerList = res;
        },
      );

    this.maxDate = new Date();

    //this below function added by deepak for account setting on 13/07/2022
    this.submitForm = this.formBuilder.group({
      APIKEY: this.APIKEY,
      user_id: [this.user_id],
      company_id: [this.company_id],
      dynamicFields: this.formBuilder.array([]),
      factInvoiceIds: '',
      soa_invoice_total: '',
      soa_account_rate: '',
      soa_account_amount: '',
    });

    const dynamicFieldForm = this.formBuilder.group({
      id: [0],
      account_id: [0],
      is_primary_account: [true],
      account_name: [''],
      account_number: [''],
      description: [''],
      account_amount: [''],
      primary_account_readonly: [false],
      is_ach: [false],
      is_wire: [false],
    });
    this.dynamicFields.push(dynamicFieldForm);
  }


  onMasterSmallSelect(i, $event) {
    if ($event.target.checked == true) {
      $('.checkImageAllOpn' + i).prop("checked", true);
    } else {
      $('.checkImageAllOpn' + i).prop("checked", false);
    }
  }

  onCheckUser(i, $event) {
    var checkvalue = 0;
    var checkvalueNum = 0;
    $('.checkImageAllOpn' + i).each(function (e) {
      checkvalueNum++;
      if ($(this).prop("checked") == true) {
        checkvalue++;
      }
    });

    if (checkvalueNum == checkvalue) {
      $('.master_small' + i).prop("checked", true);
    }
    else {
      $('.master_small' + i).prop("checked", false);
    }
  }

  checkUncheckAll($event) {
    if ($event.target.checked == true) {
      $('.checkUncheckAll').prop("checked", true);
    } else {
      $('.checkUncheckAll').prop("checked", false);
    }
  }

  onSubmitCustomer() {
    const a = this.customerModel.customer;
    const b = $(".select2").val();
    if (b == '' || b == 0) {
      this.submitted = true;
      return false;
    }

    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), b);

    this._router.navigateByUrl('/mobile/add-mobile/existing/' + encrypted);
    this.modalRef.hide();
  }

  getCustomerEmail(customer_id, invoice_id) {
    this.emailModalError = false;
    this.invoice_id = invoice_id;

    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      customer_id: customer_id,
    }

    this._contact.getContactEmailsByid(folderModel).subscribe(
      res => {
        this.emailModel = res.data;
      },
    );
  }

  sendEmailToCust() {
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      email_info: this.emailModel,
      invoice_id: this.invoice_id
    }

    this._factInvoice.sendEmailToCustomer(folderModel).subscribe(
      res => {
        this.modalRef.hide();

        if (res.status == true) {
          this.toastr.success(res.message, 'Success');
        } else {
          this.toastr.error(res.message, 'Error');
        }

        this.emailModal = false;

        this._router.navigateByUrl('/redirect').then(() => {
          this._router.navigateByUrl('/factoring/factoring-tab1');
        });
      },
      err => console.log(err)
    );

    /*if(this.emailModal){
      const rload=this;
      setTimeout(function(){  rload.emailModalError=true;}, 1500);
    }*/

  }

  getfactInvoice() {
    this.loaderMode = true;

    const invoiceModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      customer_id: this.customer_id,
      company_id: this.company_id,
      // status: 'approved',
      status: 'Need SOA',
    }

    this._factTap2.getFactFolderList(invoiceModal)
      .subscribe(
        res => {
          this.factTabList = res;
          this.temp_var = true;
          this.loaderMode = false;
        },
      );
  }

  // commented by deepak on 15/dec/2022
  // showSelectedData() {
  //     var select_fact_array = [];
  //     $(".checkImageAllOpn:checked").each(function() {
  //          select_fact_array.push($(this).val());
  //     });

  //     select_fact_array.length;
  //     if(select_fact_array.length==0){
  //          alert('Minimum one invoice is required');
  //          return false;
  //     }
  //     else{
  //         this.loaderMode=true;
  //         this.create_soa_btn=false;
  //     }

  //     const customerModal={
  //       APIKEY : this.APIKEY,
  //       user_id : this.user_id,
  //       company_id : this.company_id,
  //       fact_invoice_id: select_fact_array,
  //     }

  //     this._factInvoice.createFactoringSoa(customerModal)
  //     .subscribe(
  //       res => { 
  //         this.create_soa_btn=true;
  //         this.loaderMode=false;
  //       }, 
  //       err =>{
  //         console.log(err);
  //       }
  //     );
  // }


  /*sendEmailFactoringSoa(encrypted_company_id,encrypted_soa_id,soa_id){
    const soaModal={
      APIKEY : this.APIKEY,
      user_id : this.user_id,
      company_id : this.company_id,
      encrypted_company_id : encrypted_company_id,
      encrypted_soa_id : encrypted_soa_id,
      soa_id : soa_id,
    }
    this._factInvoice.sendEmailFactoringSoa(soaModal)
    .subscribe(
      res => { 
          if(res.status==true){
            this.toastr.success(res.message, 'Success');
          } else {
            this.toastr.error(res.message, 'Error');
          }
          
         this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/factoring/factoring-tab2');
         });
      }, 
    );
  }*/

  openModal(template: TemplateRef<any>) {

    $(function () {
      $(".select2").select2({
        placeholder: "Select"
      });
    });

    this.modalRef = this.modalService.show(template, this.config);
  }

  openModal1(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config1);
  }

  setpdfSrc(src) {
    this.pdfSrc = src;
  }

  editfactSoa(rec) {
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      mobile_id: rec,
    }
    this._factInvoice.getFolderInfo(folderModel)
      .subscribe(
        res => {
          this.model = res.data;
          this.model['date_invoice'] = this.datePipe.transform(res.data.date_invoice, 'MM/dd/yyyy');
          this.model['work_week'] = this.datePipe.transform(res.data.work_week, 'MM/dd/yyyy');
          this.model['terms'] = res.data.factterms;
        },
      );
  }

  onSubmitSoaFolder() {
    this.model['APIKEY'] = this.APIKEY;
    this.model['user_id'] = this.user_id;
    this.model['company_id'] = this.company_id;
    this.model['mode'] = 'edit';
    this.model['folder_id'] = this.model['id'];
    this.model['invoice_id'] = this.model['fact_invoice_id']
    this.model['date_invoice'] = this.datePipe.transform(this.model['date_invoice'], 'MM/dd/yyyy, hh:mm a');
    this.model['work_week'] = this.datePipe.transform(this.model['work_week'], 'MM/dd/yyyy, hh:mm a');

    this._factInvoice.factInvoiceSave(this.model).subscribe(
      res => {
        this.modalRef.hide();
        this._router.navigateByUrl('/redirect').then(() => {
          this._router.navigateByUrl('/factoring/factoring-tab1');
        });
      },
    );
  }

  set_delete_id(cid) {
    this.delete_id = cid;
  }

  /*sendEmail(){
      alert('vvvv');
  }*/

  delete_user() {
    const data = {
      invoice_id: this.delete_id,
      company_id: this.company_id,
      APIKEY: this.APIKEY,
      user_id: this.user_id,
    }

    this._factInvoice.deleteFactInvoice(data)
      .subscribe(
        res => {
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/factoring/factoring-tab1');
          });
        },
        err => console.log(err)
      );
  }


  onChangeCust(value) {
    this.customer_id = value;
    this.getfactInvoice();
  }

  onChangeFactStatus(value) {
    const data = {
      invoice_id: value,
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      status: 'opted_out',
    }

    this._factInvoice.changeFactoringStatus(data)
      .subscribe(
        res => {
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/factoring/factoring-tab1');
          });
        },
        err => console.log(err)
      );
  }

  omit_special_char(event) {
    // alert('ccc'); 
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    //alert(k);
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 45 || (k >= 48 && k <= 57));
  }


  isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

  //function added by deepak on 13/07/2022
  calculateCheckedInvoiceAmount() {
    var checkedTotalAmount = '0.00';
    $('.checkImageAllOpn').each(function () {
      if ($(this).prop("checked") == true) {
        var str = this.dataset.invamt;
        var new_inv = str.replaceAll(',', '');
        checkedTotalAmount = (parseFloat(checkedTotalAmount) + parseFloat(new_inv)).toFixed(2);
      }
    });

    if (checkedTotalAmount == '0.00') {
      this.isSoaChecked = false;
    } else {
      this.isSoaChecked = true;
    }
    this.invoice_total = checkedTotalAmount;
  }

  //function added by deepak on 13/07/2022
  openModal2(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config1);
  }

  //function added by deepak on 13/07/2022
  setAccountData() {
    this.loaderMode = true;
    this.isBtnDisabled = false;

    const modelData = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
    }

    this.dynamicFields.removeAt(0);

    this._companyService.getCompanyById(modelData).subscribe(
      res => {
        this.loaderMode = false;
        this.advance_rate = res.data.advance_rate;
        this.calculatedAdvanceRate = (this.invoice_total * this.advance_rate / 100).toFixed(2);
        this.primaryAccountAmount = this.calculatedAdvanceRate;

        if (res.dataAccount.length > 0) {
          var i = 0;
          this.dynamicFields.removeAt(0);
          for (let item of res.dataAccount) {
            const dynamicFieldForm = this.formBuilder.group({
              id: [0],
              account_id: item.account_id,
              is_primary_account: (item.is_primary_account == 1) ? true : false,
              account_name: item.account_name,
              account_number: item.account_number,
              description: item.description,
              account_amount: (item.is_primary_account == 1) ? this.primaryAccountAmount : '',
              primary_account_readonly: (item.is_primary_account == 1) ? true : false,
              is_ach: (item.is_ach == 1) ? true : false,
              is_wire: (item.is_wire == 1) ? true : false,
            });

            this.dynamicFields.push(dynamicFieldForm);
          }
        }
      },
    );
  }

  //function added by deepak on 13/07/2022
  accountFormReset() {
    this.loaderMode = false;

    this.errorMsg = false;

    var sss = new Array();
    i = 0;
    this.submitForm.value.dynamicFields.forEach(element => {
      sss.push(i);
      i++;
    });

    for (var i = sss.length - 1; i >= 0; i--) {
      this.dynamicFields.removeAt(sss[i]);
    }

  }

  //function added by deepak on 13/07/2022
  calculateAccounts(pAccAmt, event, index, ActualAmt) {
    this.errorMsg = false;
    var account_amount;
    var total = '0.00';
    this.submitForm.value.dynamicFields.forEach(element => {
      if (element.is_primary_account == false) {
        if (element.account_amount != '') {
          total = (parseFloat(total) + parseFloat(element.account_amount)).toFixed(2);
        }
      }
    });

    //if(parseFloat(eventValue)<=parseFloat(ActualAmt)){
    if (parseFloat(total) <= parseFloat(ActualAmt)) {
      if (event.target.value != '') {
        account_amount = (parseFloat(ActualAmt) - parseFloat(total)).toFixed(2);
        this.primaryAccountAmount = account_amount;
      } else {
        if (total != '0.00') {
          account_amount = (parseFloat(ActualAmt) - parseFloat(total)).toFixed(2);
          this.primaryAccountAmount = account_amount;
        } else {
          account_amount = ActualAmt;
        }
      }

      this.submitForm.value.dynamicFields.forEach(element => {
        if (element.is_primary_account == true) {
          element.account_amount = account_amount;
        }
      });

      this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
      this.isBtnDisabled = false;
    } else {
      this.errorMsg = true;
      this.isBtnDisabled = true;
    }
  }

  //function added by deepak on 13/07/2022
  uncheckall(index) {
    this.submitForm.value.dynamicFields[index].primary_account_readonly = false;
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
  }

  //function added by deepak on 13/07/2022
  onlynumber(evt) {
    this.errorMsg = false;
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode != 46 && charCode != 45 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

  //function added by deepak on 14/07/2022
  setonecheckbox(index, val) {
    var i = 0;
    this.submitForm.value.dynamicFields.forEach(element => {

      if (i == index) {
        if (val == 'ach') {
          element.is_wire = false;
          element.is_ach = true;
        }

        if (val == 'wire') {
          element.is_ach = false;
          element.is_wire = true;
        }
      }

      i++;

    });

    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
  }

  //function added by deepak on 14/07/2022
  saveAccounts() {
    var factInvoiceIdsArray = [];
    $(".checkImageAllOpn:checked").each(function () {
      factInvoiceIdsArray.push($(this).val());
    });

    factInvoiceIdsArray.length;
    if (factInvoiceIdsArray.length == 0) {
      alert('Minimum one invoice is required');
      return false;
    } else {
      this.loaderMode = true;
      this.create_soa_btn = false;
    }

    this.isBtnDisabled = true;

    this.submitForm.get('APIKEY').setValue(this.APIKEY);
    this.submitForm.get('user_id').setValue(this.user_id);
    this.submitForm.get('company_id').setValue(this.company_id);
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    this.submitForm.get('factInvoiceIds').setValue(factInvoiceIdsArray);
    //this.submitForm.get('soa_id').setValue(this.soa_fact_id);
    this.submitForm.get('soa_account_rate').setValue(this.advance_rate);
    this.submitForm.get('soa_invoice_total').setValue(this.invoice_total);
    this.submitForm.get('soa_account_amount').setValue(this.calculatedAdvanceRate);

    this._factInvoice.saveAccountsSoa(this.submitForm.getRawValue()).subscribe((res) => {
      this.modalRef.hide();
      this.create_soa_btn = true;
      this.loaderMode = false;
      this.isBtnDisabled = false;

      if (res.status == true) {
        this.toastr.success(res.message, 'Success');

        this._router.navigateByUrl('/redirect').then(() => {
          this._router.navigateByUrl('/factoring/factoring-tab2');
        });

      } else {
        this.toastr.error(res.message, 'Error');
      }

    }, err => {
      console.log(err);
    });
  }


}
